module.exports = __webpack_public_path__ + "img/22.b8e1d559.png";